var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("\n    To: "+_vm._s(_vm.bindContactPerson())+" "),_c('br'),_c('strong',[_vm._v(_vm._s(_vm.getAgentName()))]),_c('br'),_c('span',{domProps:{"innerHTML":_vm._s(_vm.bindInfo())}})])])}
var staticRenderFns = []

export { render, staticRenderFns }